module.exports = __webpack_public_path__ + "static/ROI_Calculator_en-US-8abd6bf799b290e3bd71caf5bbe15d2f.png";